import { unifiedApiKeys } from '@/services/keys';

import type { UnifiedApiParams } from '@/types/mercury-data-types/unifiedapi';

export const vulnerabilitiesKeys = {
  table: (params?: Partial<UnifiedApiParams>) =>
    ['table', ...unifiedApiKeys.records('/catalog/vulnerabilities', params)] as const,

  gfx: (context: string, params?: Partial<UnifiedApiParams>) =>
    ['/catalog/vulnerabilities', 'gfx', ...unifiedApiKeys.records(context, params)] as const,
};
